import React, { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { signout, isAuthenticated } from '../apiCallsHelper/authapicalls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faClipboard, faHand, faWrench, faUserLock, faBars, faHouseLock, faDoorOpen, faCircleUser, faDoorClosed } from '@fortawesome/free-solid-svg-icons';
import todoLogo from "../images/TodoMate-logo.png"



const currentTab = (history, path) => {
    if (window.location.pathname === path) {
        return {
            background: "#5f7ac2",
            color: "#fff",
            fontWeight: "bold",
        }
    }
    else {
        return { color: "#113282" }
    }
}




const Navbar = ({ history }) => {

    const navigate = useNavigate();

    const { user } = isAuthenticated();

    const [isOpenDropdown, setIsOpenDropdown] = useState(false);
    const [isHamburgerMenuClicked, setIsHamburgerMenuClicked] = useState(false);



    const handleHamburgerMenu = () => {
        setIsHamburgerMenuClicked(!isHamburgerMenuClicked);
    }



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".navbar-dropdown")) {
                setIsOpenDropdown(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);





    return (
        <>

            <nav className="mobileNavContainer  flex h-10 flex items-stretch  w-full sticky top-0 z-50 bg-[#b6cafc]  md:hidden">
                <div>
                    <img src={todoLogo} className=' w-[40px] h-[40px]    xs:w-[70px] xs:h-[70px]   sm:w-[75px] sm:h-[75px]' alt="todo-logo" />
                </div>
                <div onClick={handleHamburgerMenu} className='mr-4 py-2 ml-auto'>
                    <FontAwesomeIcon icon={faBars} size='xl' color='#ffffff' />
                </div>
                {isHamburgerMenuClicked ? (
                    <>
                        <div id="hamburgerMenu" className={`fixed top-0 left-0 right-0 bottom-0  bg-[#d1dfff]   text-md xs:text-lg  sm:text-xl   `}>
                            <div className='py-4 mr-4 flex justify-end'>
                                <FontAwesomeIcon onClick={handleHamburgerMenu} icon={faBars} className='  ' size='xl' color='black' />
                            </div>
                            <div className=' flex flex-col items-center justify-center text-center text-[#314778]  h-screen  '>
                                {!isAuthenticated() && (
                                    <>
                                        <Link to="/" className="w-full  font-semibold  px-4 py-6 border-t-2 border-gray-100 rounded hover:bg-gray-100 hover:text-gray-900 transition-all duration-300"><FontAwesomeIcon icon={faHouse} className='mr-2' />
                                            Home
                                        </Link>
                                        <Link to="/signup" className="w-full  font-semibold  px-4 py-6 border-t-2 border-gray-100 rounded hover:bg-gray-100 hover:text-gray-900 transition-all duration-300"> <FontAwesomeIcon icon={faCircleUser} className='mr-2' />
                                            Sign up
                                        </Link>
                                        <Link to="/signin" className=" w-full font-semibold  px-4 py-6 border-y-2 border-gray-100 rounded hover:bg-gray-100 hover:text-gray-900 transition-all duration-300"> <FontAwesomeIcon icon={faDoorClosed} className='mr-2' />
                                            Login
                                        </Link>
                                    </>
                                )}
                                {isAuthenticated() && (
                                    <>
                                        <div className="w-full  font-bold mt-4  px-4 py-6  xs:text-xl sm:text-2xl transition-all duration-300">
                                            Hello,  {user.fname}!
                                        </div>
                                        <Link to="/" className="w-full  font-semibold  px-4 py-6 border-t-2 border-gray-100 rounded hover:bg-gray-100 hover:text-gray-900 transition-all duration-300"><FontAwesomeIcon icon={faHouse} className='mr-2' />
                                            Home
                                        </Link>
                                        <Link to="/user/dashboard" className=" w-full font-semibold  px-4 py-6 border-t-2 border-gray-100 rounded hover:bg-gray-100 hover:text-gray-900 transition-all duration-300"> <FontAwesomeIcon icon={faClipboard} className='mr-2' />
                                            Dashboard
                                        </Link>
                                        {user.role === 25 &&
                                            (
                                                <Link to="/admin/dashboard" className=" w-full font-semibold  px-4 py-6 border-t-2 border-gray-100 rounded hover:bg-gray-100 hover:text-gray-900 transition-all duration-300"><FontAwesomeIcon icon={faHouseLock} />
                                                    Admin Dashboard
                                                </Link>
                                            )
                                        }
                                        <Link to="/user/account" className=" w-full font-semibold  px-4 py-6 border-t-2 border-gray-100 rounded hover:bg-gray-100 hover:text-gray-900 transition-all duration-300"><FontAwesomeIcon icon={faWrench} />
                                            Account settings
                                        </Link>
                                        <div onClick={() => { signout(() => { navigate("/"); }) }} className="w-full text-red-500 font-semibold mb-8 px-6 py-4 border-y-2 border-gray-100 rounded hover:bg-gray-100 hover:text-gray-900 transition-all duration-300"><FontAwesomeIcon icon={faDoorOpen} className='mr-1' />
                                            Sign out
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </>
                ) : null}
            </nav>




            <nav className="hidden   md:flex md:items-stretch   w-full sticky top-0 z-50 bg-[#b6cafc]">
                <div className="md:flex md:flex-no-shrink md:items-stretch md:h-14 ">
                    <div className='mr-1'>
                        <img src={todoLogo} className='md:w-[80px] md:h-[80px]     smLaptop:w-[90px] smLaptop:h-[90px]    lg:w-[90px] lg:h-[90px]  xl:w-[110px] xl:h-[110px]' alt="todo-logo" />
                    </div>
                    <Link style={currentTab(history, "/")} className="hidden   md:flex items-center md:flex-no-grow md:flex-no-shrink  md:py-2 md:px-4 relative leading-normal no-underline hover:!shadow-lg hover:!shadow-[#bac4db]" to="/">
                        <FontAwesomeIcon icon={faHouse} className='mr-2' /> Home
                    </Link>
                    {isAuthenticated() && isAuthenticated().user.role === 0 && (
                        <Link style={currentTab(history, "/user/dashboard")} className="  hidden  md:flex items-center md:flex-no-grow md:flex-no-shrink md:py-2 md:px-4 relative leading-normal  no-underline hover:!shadow-lg hover:!shadow-[#bac4db]" to="/user/dashboard">
                            <FontAwesomeIcon icon={faClipboard} className='mr-2' /> Dashboard
                        </Link>
                    )}
                    {isAuthenticated() && isAuthenticated().user.role === 25 && (
                        <>
                            <Link style={currentTab(history, "/admin/dashboard")} className="  hidden  md:flex items-center md:flex-no-grow md:flex-no-shrink md:py-2 md:px-4 relative leading-normal  no-underline hover:!shadow-lg hover:!shadow-[#bac4db]" to="/admin/dashboard">
                                <FontAwesomeIcon icon={faHouseLock} className='mr-2' /> Admin Dashboard
                            </Link>
                            <Link style={currentTab(history, "/user/dashboard")} className="  hidden  md:flex items-center md:flex-no-grow md:flex-no-shrink md:py-2 md:px-4 relative leading-normal  no-underline hover:!shadow-lg hover:!shadow-[#bac4db]" to="/user/dashboard">
                                <FontAwesomeIcon icon={faClipboard} className='mr-2' /> Dashboard
                            </Link>
                        </>
                    )}
                </div>
                <div className="hidden  md:flex md:items-stretch md:flex-no-shrink md:flex-grow">
                    <div className="ml-auto md:flex lg:flex lg:items-stretch lg:justify-end">
                        {!isAuthenticated() && (
                            <Fragment>
                                <Link style={currentTab(history, "/signup")} className="flex-no-grow flex-no-shrink relative py-2 px-4 leading-normal text-white no-underline flex items-center hover:bg-grey-dark" to="/signup">
                                    <FontAwesomeIcon icon={faCircleUser} className='mr-2  text-lg ' /> Sign Up
                                </Link>
                                <Link style={currentTab(history, "/signin")} className="flex-no-grow flex-no-shrink relative py-2 px-4 leading-normal text-white no-underline flex items-center hover:bg-grey-dark" to="/signin">
                                    <FontAwesomeIcon icon={faDoorClosed} className='mr-2' /> Sign In
                                </Link>
                            </Fragment>
                        )}
                        {isAuthenticated() && (
                            <li className="flex-no-grow flex-no-shrink relative py-2 px-4 leading-normal text-white no-underline flex items-center hover:bg-grey-dark">
                                <div className='mr-4 text-[#345299] font-semibold hover:text-[#5b6e45]'>
                                    Hello, {user.fname}  <FontAwesomeIcon icon={faHand} className='origin-center rotate-12 hover:scale-125 hover:rotate-45' />
                                </div>
                                <div className="relative inline-block text-left">
                                    <div>
                                        <button onClick={() => setIsOpenDropdown(!isOpenDropdown)} type="button" className="navbar-dropdown inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-[#506499] shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" id="menu-button" aria-expanded="true" aria-haspopup="true">
                                            <FontAwesomeIcon icon={faUserLock} className='mt-[3px]' /> Your Account
                                            <svg className="-mr-1 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className={`absolute right-0 z-10 mt-2 w-[155px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  ${isOpenDropdown ? "block" : "hidden"}`} role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                                        <Link className="text-gray-500 block px-4 py-2 text-sm cursor-pointer" role="menuitem" tabIndex="-1" id="menu-item-0" to="/user/account"><FontAwesomeIcon icon={faWrench} /> Account settings</Link>
                                        <div onClick={() => { signout(() => { navigate("/"); }) }} className="text-red-500 block px-4 py-2 text-sm cursor-pointer" role="menuitem" tabIndex="-1" id="menu-item-3"> <FontAwesomeIcon icon={faDoorOpen} className='mr-1' /> Sign out</div>
                                    </div>
                                </div>
                            </li>
                        )}
                    </div>
                </div>
            </nav>

        </>
    )
}





export default Navbar;